import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantAddService } from '../../services/merchant-add.service';

@Component({
  selector: 'app-add-merchant',
  templateUrl: './add-merchant.component.html',
  styleUrls: ['./add-merchant.component.scss']
})
export class AddMerchantComponent implements OnInit {


  errorMessage = "";
  constructor(
    private MerchantAdd : MerchantAddService,
    private route : Router,
    private cdr : ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  async addMerchant(event){
    this.MerchantAdd.setParams(event);
    try{
      let res = await this.MerchantAdd.make();
      if(res.success){
        this.route.navigate(['/admin/actions/merchants'])
      } else {
        this.errorMessage = res.message;
      }
    }catch(err){
        this.errorMessage = err.faultyRequest.error.message;
        this.cdr.detectChanges()
    }
  }


}
